var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moreBtn"},[_c('Button',{attrs:{"loading":_vm.anLoading,"disabled":_vm.isForbid},on:{"click":_vm.viewMore}},[_vm._v(_vm._s(_vm.moreTxt))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4843e8a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/teacher/components/loadingMore.vue
// module id = null
// module chunks = 